// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"e20c5a7ef4c5e717c679","276":"2d7393ba08fd0a26c77c"}[chunkId] + ".js";
};